import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import { BlockType, CodeBlock } from '@appblocks/codegeneration/types';
import { RUNTIMES } from '@appblocks/platforms/PlatformUtils';
import * as micropython from './micropython';
import * as tios from './tios';


export default class Time extends BaseFeature {
    constructor() {
        super();
        this.id = 'time';
        this.name = 'Time';
        this.fileLinks = [
            // 'time\\time.tbs',
            // 'time\\time.tbh',
        ];
    }

    getFiles(): string[] {
        if (this.project.runtime === RUNTIMES.TIOS) {
            return [
                'libraries/time/time.tbh',
                'libraries/time/time.tbs',
            ];
        }
        if (this.project.runtime === RUNTIMES.MICROPYTHON) {
            return [
                'datetime.py',
            ];
        }
        return [];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'simulator':
                return [];
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
